import { arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import { isConversationalWorkflowResultObject } from "../conversationalWorkflow";

export const isConversationalWorkflowsResult = objectOf({
  hits: number,
  results: arrayOf(isConversationalWorkflowResultObject),
});
